import React, { useState } from 'react';
import { Info } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

const BRONZE = '#b89968';  // info icon + "Sample data shown..." text

interface SampleDataBannerProps {
  /** Called after the fade-out completes, so the parent can flip sample mode off. */
  onDismiss: () => void;
}

/**
 * Full-width notice shown directly below the header while the dashboard is
 * displaying demo data. Fades out before the parent removes it.
 */
export function SampleDataBanner({ onDismiss }: SampleDataBannerProps) {
  const { theme } = useTheme();
  const [leaving, setLeaving] = useState(false);

  const textColor    = BRONZE;
  const dismissColor = theme === 'dark' ? 'rgba(244,241,234,0.6)' : 'rgba(26,24,20,0.6)';
  const dismissHover = theme === 'dark' ? '#f4f1ea' : '#1a1814';

  const handleDismiss = () => {
    setLeaving(true);
    // Let the opacity transition play before the parent unmounts the banner.
    window.setTimeout(onDismiss, 280);
  };

  return (
    <div
      style={{
        backgroundColor: 'rgba(212,180,131,0.06)',
        borderBottom: '0.5px solid rgba(212,180,131,0.2)',
        padding: '12px 24px',
        opacity: leaving ? 0 : 1,
        transition: 'opacity 0.28s ease',
      }}
    >
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-2.5 min-w-0">
          <Info className="w-4 h-4 flex-shrink-0" style={{ color: BRONZE }} />
          <span className="text-[13px] sm:text-[14px]" style={{ color: textColor }}>
            Sample data shown. Add your first transaction to see your real portfolio.
          </span>
        </div>
        <button
          onClick={handleDismiss}
          className="text-[13px] flex-shrink-0 transition-colors hover:opacity-100"
          style={{ color: dismissColor, background: 'transparent', border: 'none', cursor: 'pointer' }}
          onMouseEnter={(e) => { e.currentTarget.style.color = dismissHover; }}
          onMouseLeave={(e) => { e.currentTarget.style.color = dismissColor; }}
        >
          Dismiss
        </button>
      </div>
    </div>
  );
}
